import React, { useState } from "react";
import FieldRouter from "./FieldRouter";
import { ChevronDown, ChevronRight } from "lucide-react";

const ObjectSection = ({ label, value, onChange, path, compact, initiallyOpen = true }) => {
  const [open, setOpen] = useState(initiallyOpen);
  const obj = value || {};

  const setKey = (k, v) => onChange({ ...obj, [k]: v });

  if (compact) {
    return (
      <div className="space-y-3">
        {Object.entries(obj).map(([k, v]) => (
          <FieldRouter key={k} keyName={k} value={v} onChange={(nv) => setKey(k, nv)} path={`${path}.${k}`} />
        ))}
      </div>
    );
  }

  return (
    <section className="border border-zinc-200 rounded-lg bg-white" data-testid={`section-${path}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-5 py-3 border-b border-zinc-100 hover:bg-zinc-50"
      >
        <div className="flex items-center gap-2 text-sm font-medium text-zinc-900">
          {open ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          {label}
        </div>
        <span className="text-[10px] tracking-wider text-zinc-400 uppercase">{Object.keys(obj).length} fields</span>
      </button>
      {open && (
        <div className="px-5 py-5 space-y-4">
          {Object.entries(obj).map(([k, v]) => (
            <FieldRouter key={k} keyName={k} value={v} onChange={(nv) => setKey(k, nv)} path={`${path}.${k}`} />
          ))}
        </div>
      )}
    </section>
  );
};

export default ObjectSection;
